import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/identityPolicyServices'

export default {
  async getAllPredefined() {
    return await axios
      .get(`${endpoint}/list`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/identity/identityPolicySvcService.js